import { KnowledgeFileType } from "../api/models";

export const DOCUMENT_EXTENSIONS = [".pdf", ".docx", ".xls", ".xlsx", ".txt", ".csv"] as const;
export const DOCUMENT_ACCEPT = DOCUMENT_EXTENSIONS.join(",");
export const DOCUMENT_TYPES_LABEL = "PDF, DOCX, XLS, XLSX, TXT, CSV";
export const KNOWLEDGE_ACCEPT = `${DOCUMENT_ACCEPT},.mp4`;

const LEGACY_OFFICE_REPLACEMENTS: Record<string, string> = {
    ".doc": ".docx"
};

function getExtension(fileName: string): string {
    const dotIndex = fileName.lastIndexOf(".");
    return dotIndex === -1 ? "" : fileName.slice(dotIndex).toLowerCase();
}

export function isSupportedDocument(fileName: string): boolean {
    return (DOCUMENT_EXTENSIONS as readonly string[]).includes(getExtension(fileName));
}

export function legacyOfficeMessage(fileName: string): string | null {
    const ext = getExtension(fileName);
    const replacement = LEGACY_OFFICE_REPLACEMENTS[ext];
    if (!replacement) {
        return null;
    }
    return `"${fileName}" uses the legacy ${ext} format. Please save it as ${replacement} and upload it again.`;
}

export function getKnowledgeFileType(fileName: string): KnowledgeFileType | null {
    if (getExtension(fileName) === ".mp4") {
        return "video";
    }
    return isSupportedDocument(fileName) ? "document" : null;
}

export function knowledgeRejectionMessage(fileName: string): string {
    return legacyOfficeMessage(fileName) ?? `File "${fileName}" must be a ${DOCUMENT_TYPES_LABEL} or MP4 file.`;
}

// Browsers render PDF and plain text in an iframe; the other document formats
// trigger a download instead, so the citation panel shows a fallback for them.
const BROWSER_RENDERABLE_EXTENSIONS = [".pdf", ".txt"];

export function citationFileName(citationUrl: string): string {
    const path = citationUrl.split("#")[0].split("?")[0];
    const lastSlash = path.lastIndexOf("/");
    return lastSlash === -1 ? path : path.slice(lastSlash + 1);
}

export function isBrowserRenderable(citationUrl: string): boolean {
    return BROWSER_RENDERABLE_EXTENSIONS.includes(getExtension(citationFileName(citationUrl)));
}
